import React from 'react'

import { ThemeProvider, DefaultTheme } from 'styled-components'
import SEO from 'src/components/Seo'
import Footer from 'src/components/Footer'
import GlobalStyle from 'src/styles/global'
import Main from 'src/styles/themes/main'
import Themes from 'src/styles/themes'

import Hero from './sections/hero/_index'
import ExclusiveContent from './sections/exclusive-content/_index'
import OurTimeOfExperts from './sections/our-time-of-experts/_index'
import Faq from './sections/faq/_index'
import pageContext from './pageContext.json'

const getActiveTheme = () => {
  const activeTheme = Object.values(Themes).find((theme) => {
    if (!pageContext?.categoria) {
      return false
    }

    const categoria = JSON.stringify(pageContext.categoria)
    return categoria.includes(theme.title)
  })

  return activeTheme || Main
}

const News = () => (
  <ThemeProvider theme={getActiveTheme() as DefaultTheme}>
    <GlobalStyle />
    <SEO
      title={pageContext.metaTitle}
      url={`${process.env.BASE_URL}/news`}
      meta={[
        {
          name: 'description',
          content: pageContext.metaDescription,
        },
        {
          property: 'og:title',
          content: pageContext.metaTitle,
        },
        {
          property: 'og:description',
          content: pageContext.metaDescription,
        },
      ]}
    />
    <Hero />
    <ExclusiveContent />
    <OurTimeOfExperts />
    <Faq />
    <Footer />
  </ThemeProvider>
)

export default News
